import { createRouter, createWebHashHistory  } from 'vue-router'
import MainComponent from '../components/MainComponent.vue'

const routes = [
  { path: '/:id', component: MainComponent, props: true },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
